import axios from "axios";
import {DepartmentListParams, EQDepartment} from "../../models/serverModels/EQDepartment";
import {
  ResponseList,
  ResponseItem,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

const department = axios.create({
  baseURL: "/api",
});

export const getList = async (params: DepartmentListParams): Promise<ResponseList<EQDepartment>> =>
  department({
    url: "/departmentList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQDepartment>> =>
  department({
    url: `/department/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<EQDepartment>
): Promise<ResponseItem<EQDepartment>> =>
  department({
    url: `/department`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  department({
    url: `/department/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EQDepartment>
): Promise<ResponseItem<EQDepartment>> =>
  department({
    url: `/department/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
